import React from "react";
import "./SingleBlogPostHeroSection.scss";
import WebPicture from "../../layout/WebPicture";
import { formatDateToString } from "../../utils/helpers";

const SingleBlogPostHeroSection = ({ data }) => {
  let img_data = {
    webp: "",
    img: data?.thumb,
    title: data?.title?.rendered,
    class: "single-blog-hero-image",
  };
  return (
    <section className={"single-blog-post-hero-section"}>
      <div className={"container"}>
        <div className={"row"}>
          <div className="row">
            <div className="col-8 offset-2 date-category">
              <span className="date-published">
                {formatDateToString(data?.date)}
              </span>
              {data.categories_name?.length ? <span></span> : ""}
              {data.categories_name?.length
                ? data.categories_name.map((category, j) => {
                    const style = {
                      "--color": category?.color || "#009FE3",
                    };

                    return (
                      <span key={j} style={style}>
                        {category.name}
                      </span>
                    );
                  })
                : ""}
            </div>
          </div>
          <div className={"col-8 offset-2"}>
            <h1 className={"section-heading"}>{data?.title?.rendered}</h1>
          </div>
          {data?.excerpt.rendered.length && (
            <div className={"col-8 offset-2 excerpt"}>
              <div>{data?.excerpt?.rendered}</div>
            </div>
          )}
        </div>
      </div>
      {data?.thumb.length && (
        <div className="featured-image">
          <WebPicture data={img_data} />
        </div>
      )}
      {/* <div className="container">
        <div className="row">
          <div
            className={"col-8 offset-2 post-content"}
            dangerouslySetInnerHTML={{ __html: data?.content?.rendered }}
          ></div>
        </div>
      </div> */}
    </section>
  );
};

export default SingleBlogPostHeroSection;
